import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeviceState } from 'console/shared/contexts/device/state/types';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { memo, useCallback, useContext, useMemo, } from 'react';
import { createSubsetSelector } from 'webui/utils/selectors';
import { createSelector } from '@reduxjs/toolkit';
import { LegacyDevice } from 'console/device/device';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { requestDeviceUpdate } from 'console/redux/devices/items/actions';
import { OpenThermStatusFlag } from 'openTherm';
import { selectSelectedDevice } from 'entities/device/lib';
// const thumblers_device = createSelector<AppState, Device | undefined, ThumblersDevice>(
const thumblers_device = createSelector((state) => selectSelectedDevice(state), createSubsetSelector([
    'thermostat_gate',
    'ot_enabled',
    'ot_gate_enabled',
    'thermostat_inputconfig',
    'ot_config',
    'ot_show_dhw_control',
]));
export const LegacyThumblers = memo(function LegacyThumblers() {
    const device = useAppSelector(thumblers_device);
    const { external_panel_turned_on, ot_config, dhw_turned_on, show_dhw, show_external_panel, } = useMemo(() => {
        if (device) {
            const { thermostat_gate, ot_enabled, ot_config, ot_show_dhw_control } = device;
            const show_dhw = ot_enabled && ot_config && ot_show_dhw_control;
            const show_external_panel = LegacyDevice.thermostat_gate_available({
                ot_enabled: !!device.ot_enabled,
                ot_gate_enabled: !!device.ot_gate_enabled,
                thermostat_inputconfig: device.thermostat_inputconfig,
            });
            return {
                external_panel_turned_on: thermostat_gate ?? false,
                dhw_turned_on: (show_dhw && ot_config.includes(OpenThermStatusFlag.dhw)) ?? false,
                show_dhw,
                show_external_panel,
                ot_config: ot_config,
            };
        }
        return {
            external_panel_turned_on: false,
            dhw_turned_on: false,
            show_dhw: false,
            show_external_panel: false,
            ot_config: null,
        };
    }, [device]);
    const onUpdateDevice = useAction(requestDeviceUpdate);
    const { online } = useContext(DeviceState);
    const { is_guest, device_id } = useContext(DeviceConfig);
    const onExternalPanelChange = useCallback((_, thermostat_gate) => onUpdateDevice(device_id, { thermostat_gate }, {
        ignore_server_response: true,
        obey_only_last_response: true,
    }), [device_id]);
    const disabled = useMemo(() => !online || is_guest, [online, is_guest]);
    const onDwhChange = useCallback((_, dhw_enabled) => {
        if (!ot_config) {
            return;
        }
        const flags = Object.fromEntries(ot_config.map((flag) => [flag, true]));
        if (dhw_enabled) {
            flags['dhw'] = true;
        }
        else {
            delete flags['dhw'];
        }
        const new_ot_config = Object.keys(flags);
        onUpdateDevice(device_id, { ot_config: new_ot_config }, {
            ignore_server_response: true,
            obey_only_last_response: true,
        });
    }, [ot_config, device_id]);
    return (_jsxs(Box, { display: "flex", justifyContent: "center", mt: 1, children: [show_external_panel && (_jsx(FormControlLabel, { onChange: onExternalPanelChange, control: _jsx(Switch, { checked: external_panel_turned_on, color: "primary", disabled: disabled }), label: "\u041A\u043E\u043C\u043D\u0430\u0442\u043D\u044B\u0439 \u0442\u0435\u0440\u043C\u043E\u0441\u0442\u0430\u0442" })), show_dhw && (_jsx(FormControlLabel, { onChange: onDwhChange, control: _jsx(Switch, { checked: dhw_turned_on, color: "primary", disabled: disabled }), label: "\u0413\u043E\u0440\u044F\u0447\u0430\u044F \u0432\u043E\u0434\u0430" }))] }));
});
